/* Gold Drop Vodka: runs on every page (Flaviar links, age gate, menu, reveal, footer year) */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ============================================================
     FLAVIAR LINKS
     Gold Drop sells and ships online through Flaviar. Every link marked
     data-shop="shop", "login" or "cart" uses these addresses: the header
     Log in, the phone menu, the footer Buy column and the shop buttons.
     Set them in Shopify: Online Store > Themes > Customize >
     Theme settings > "Online shop: Flaviar". While the product page is
     empty, "Shop online" shows a short "coming soon" note.
     ============================================================ */
  var GD = window.GD || {};
  var FLAVIAR = {
    product: GD.flaviarProduct || "",
    login: GD.flaviarLogin || "https://flaviar.com/account/login",
    cart: GD.flaviarCart || "https://flaviar.com/cart",
    openInNewTab: true
  };
  (function wireFlaviar() {
    var links = document.querySelectorAll("[data-shop]"), note = null, timer = null;
    var map = { shop: FLAVIAR.product, login: FLAVIAR.login, cart: FLAVIAR.cart };
    function show(msg) {
      if (!note) { note = document.createElement("p"); note.className = "shop-note"; note.setAttribute("role", "status"); document.body.appendChild(note); }
      note.textContent = msg; note.hidden = false;
      clearTimeout(timer); timer = setTimeout(function () { note.hidden = true; }, 3200);
    }
    Array.prototype.forEach.call(links, function (a) {
      var url = map[a.getAttribute("data-shop")];
      if (url) {
        a.href = url;
        if (FLAVIAR.openInNewTab) { a.target = "_blank"; a.rel = "noopener"; }
      } else {
        a.addEventListener("click", function (e) { e.preventDefault(); show("Gold Drop on Flaviar is coming soon."); });
      }
    });
  })();


  /* age gate: month, day and year */
  var gate = document.getElementById("gate"), passed = false;
  try { passed = sessionStorage.getItem("gd-age") === "ok"; } catch (e) {}
  if (passed) gate.hidden = true;
  document.getElementById("gate-form").addEventListener("submit", function (ev) {
    ev.preventDefault();
    var m = parseInt(document.getElementById("dob-m").value, 10), d = parseInt(document.getElementById("dob-d").value, 10), y = parseInt(document.getElementById("dob-y").value, 10);
    var err = document.getElementById("gate-err"), now = new Date();
    if (!(m >= 1 && m <= 12 && d >= 1 && d <= 31 && y >= 1900 && y <= now.getFullYear())) { err.textContent = "Enter a real date, like 07 / 14 / 1990."; return; }
    if (new Date(y, m - 1, d).getMonth() !== m - 1) { err.textContent = "That day doesn't exist in that month. Check the date."; return; }
    var age = now.getFullYear() - y - ((now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d)) ? 1 : 0);
    if (age < 21) { err.textContent = "We're sorry. You need to be 21 or older to visit. Learn more at responsibility.org."; return; }
    try { sessionStorage.setItem("gd-age", "ok"); } catch (e) {}
    gate.hidden = true;
  });
  ["dob-m", "dob-d"].forEach(function (id, i) {
    var el = document.getElementById(id);
    el.addEventListener("input", function () { el.value = el.value.replace(/\D/g, ""); if (el.value.length === 2) document.getElementById(i === 0 ? "dob-d" : "dob-y").focus(); });
  });
  document.getElementById("dob-y").addEventListener("input", function (e) { e.target.value = e.target.value.replace(/\D/g, ""); });

  /* menu */
  var menu = document.getElementById("menu"), openBtn = document.getElementById("menu-open");
  function setMenu(open) { menu.hidden = !open; openBtn.setAttribute("aria-expanded", open ? "true" : "false"); document.body.style.overflow = open ? "hidden" : ""; if (open) document.getElementById("menu-close").focus(); }
  openBtn.addEventListener("click", function () { setMenu(true); });
  document.getElementById("menu-close").addEventListener("click", function () { setMenu(false); openBtn.focus(); });
  menu.addEventListener("click", function (e) { if (e.target.closest("nav a")) setMenu(false); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !menu.hidden) { setMenu(false); openBtn.focus(); } });

  /* reveal */
  if (!reduce && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } }); }, { rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) io.observe(el); });
  }

  var yr = document.getElementById("yr"); if (yr) yr.textContent = new Date().getFullYear();
})();
